import React, { useEffect, useState } from 'react'
import System from 'src/helper/system';
import QuoteDetail from '@system/config/quote';
import { QuoteDetailSearchFilter } from './DetailFilter/QuoteDetailSearchFilter';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import NoResultContent from '../HomePageContent/NoResultContent';
import Constants from 'src/helper/Constants';
import ApprovedTabList from './QuoteDetailTab/ApprovedTabList';
import PendingTabList from './QuoteDetailTab/PendingTabList';
import NoBidTabList from './QuoteDetailTab/NoBidTabList';
import BookedTabList from './QuoteDetailTab/BookedTabList';
import { useQuoteStore } from 'src/hooks/quote';
import { useProductStore } from 'src/hooks/product';
import QuoteConfig from "@system/config/quote";
import { __remove, __set } from 'src/store/axios_indicator';
import Quote from "@system/config/quote";
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import Helper from 'src/helper/Helper';
import ResponseMaker from 'src/service/reponseMaker/productResponseMaker';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const c = System.getParams();

const QuoteDetailTabsListing = (props) => {
    const { QuoteTabList: { APR, BKD, PND, NBD }, currencyType: { USD } } = Constants
    const QuoteTabType = System.getParams().__c_QuoteDetailTabList || APR.param_value;
    const QuoteTabTypeName = QuoteTabType === APR.param_value ? 'Approved' : QuoteTabType === BKD.param_value ? 'Booked' : QuoteTabType === PND.param_value ? 'Pending' : QuoteTabType === NBD.param_value ? 'NoBid' : 'Expired'
    let defaultTabList = {
        APR: {
            name: APR.name,
            param_value: APR.param_value,
            count: 0
        },
        PND: {
            name: PND.name,
            param_value: PND.param_value,
            count: 0
        },
        NBD: {
            name: NBD.name,
            param_value: NBD.param_value,
            count: 0
        },
        BKD: {
            name: BKD.name,
            param_value: BKD.param_value,
            count: 0
        },
    };
    const [homeTabList, setHomeTabList] = useState(defaultTabList)
    const [__check] = useAxiosIndicatorCheck();
    const quoteNumber = c.quote_number;
    let [noResultForCheckout, setNoResultForCheckout] = useState(false);
    let [noResultForRFQ, setNoResultForRFQ] = useState(false);
    const [selectedTab, setSelectedTab] = useState()
    const [{ get_current_quote_cart, line_items, submittedQuoteList }, { fetch_submitted_quote_list }, { add_multiple_quote }] = useQuoteStore();
    const [currentTabDetail, setCurrentTabDetail] = useState(line_items[QuoteTabTypeName])
    const [{ productList }, { }, { }] = useProductStore();
    const [{ pricing_list }, { }, { }] = useProductInventoryPriceStore();
    const now = new Date()
    const isQuoteDate = new Date(submittedQuoteList?.records?.[0]?.quoteExpirationDate)
    const isQuoteExpired = isQuoteDate < now
    const quoteList = get_current_quote_cart();

    useEffect(() => {
        setSelectedTab(QuoteTabType !== undefined ? QuoteTabType : homeTabList.APR.param_value)
    }, [QuoteTabType])

    useEffect(() => {
        const fetchAPICall = async () => {
            __set('QUOTE_API_CALL');
            const res = await fetch_submitted_quote_list({
                "pageNumber": 1,
                "pageSize": 1,
                "sortBy": '',
                "sortType": "",
                "quoteNumber": quoteNumber,
                "requiredAddressDetails": false
            })
            if (res?.payload?.records?.length === 0) {
                window.location.href = Quote.getSubmittedQuoteAbsoluteUrl()
            }
            __remove('QUOTE_API_CALL')
        };
        fetchAPICall();
    }, []);

    useEffect(() => {
        const temData = { ...homeTabList }
        temData.APR.count = line_items?.Approved?.count || 0
        temData.BKD.count = line_items?.Booked?.count || 0
        temData.NBD.count = line_items?.NoBid?.count || 0
        temData.PND.count = line_items?.Pending?.count || 0
        setCurrentTabDetail(line_items[QuoteTabTypeName])
        setHomeTabList(temData)
    }, [QuoteTabType, line_items])

    useEffect(() => {
        if (noResultForCheckout === true) {
            setNoResultForCheckout(false)
        }

    }, [quoteList]);

    const getActiveClass = (singleElement) => {
        if (homeTabList[selectedTab]?.param_value === singleElement.param_value) {
            return 'active'
        }
        return ''
    };

    const getTabLink = (singleElement) => {
        setSelectedTab(singleElement.param_value)
        return QuoteDetail.getQuoteDetailTabsListRouteURL({
            ...c,
            ['__c_QuoteDetailTabList']: singleElement.param_value
        });
    };

    const switchTab = async (url) => {
        history.pushState('', '', url);
    };

    const onRequestQuote = async () => {
        if (Object.entries(quoteList)?.length > 0) {
            __set('REQUEST_NEW_QUOTE')
            setNoResultForRFQ(false)
            const res = await add_multiple_quote({ product: productList, quoteList: quoteList, pricing_list: pricing_list });
            if (res?.isSuccessFull) {
                window.location.href = QuoteConfig.getQuoteRouteURL();
                __remove('REQUEST_NEW_QUOTE')
            }

        } else {
            setNoResultForRFQ(true)
        }
    };

    const onBuyNow = () => {
        if (Object.entries(quoteList)?.length > 0) {
            let res = []
            let productObj = {}
            Object.entries(quoteList).map(ele => {
                let res_made = new ResponseMaker({ data: { products: [productList[ele[1].ERPPartNumber]] } }).process().run().get();
                const products = { ...res_made?.value?.[0] }
                productObj = {
                    AllocationFlag: products?.AllocationFlag,
                    assetURL: products?.AssetURL,
                    erpMfrPartNumber: products?.ERPMFRPartNumber,
                    partNumber: products?.ERPPartNumber,
                    EndOfLifeFlag: products?.EndOfLifeFlag,
                    ExcessInventoryFlag: products?.ExcessInventoryFlag,
                    HazardousFlag: products?.HazardousFlag,
                    itemNumber: products?.ItemNumber,
                    NCNRFlag: products?.NCNRFlag,
                    ObsoleteFlag: products?.ObsoleteFlag,
                    ROHSCompliantCode: products?.ROHSCompliantCode,
                    ROHSCompliantCodeValue: products?.ROHSCompliantCodeValue,
                    SAPMaterialPricingGroupCode: products?.SAPMaterialPricingGroupCode,
                    SoftwareDownloadFlag: products?.SoftwareDownloadFlag,
                    TopSellerFlag: products?.TopSellerFlag,
                    PackagingTypeCode: products?.PackagingTypeCode,
                    WebOnlyFlag: products?.WebOnlyFlag,
                    NPIFlag: products?.NPIFlag,
                    IsDesignsAvailable: products?.IsDesignsAvailable,
                    IsTariffEligible: products?.IsTariffEligible,
                    manufacturerName: products?.ManufacturerName,
                    mdmMaterialId: products?.MDMMaterialID,
                    manufacturerCode: products?.ManufacturerCode,
                    erpManufacturerName: products?.ERPManufacturerName,
                    erpManufacturerCode: products?.ERPManufacturerCode,
                    vendorCode: products?.VendorCode,
                    sapMatGroup: products?.SAPMatgroup,
                    default_plant: products?.default_plant,
                    distributor: products?.distributor,
                    sap_tla_type_cd: products?.sap_tla_type_cd,
                    schedulableFlag: products?.SchedulableFlag,
                    eccnCode: products?.ECCNCode,
                    backOrderedQuantity: 0,
                    addedFromBom: false,
                    isSoftwareDownloadable: products?.SoftwareDownloadFlag,
                    currency: USD,
                    erpSupplierCode: products?.ERPSupplierCode,
                    originated: submittedQuoteList?.records?.[0].originated,
                    SEOManufacturerName: products?.SEOManufacturerName,
                    SEOERPMFRPartNumber: products?.SEOERPMFRPartNumber
                }

                res.push({
                    ...productObj,
                    partNumber: ele[1].ERPPartNumber,
                    additionalCharge1: ele[1].additionalCharge1 ? ele[1].additionalCharge1 : 0,
                    additionalCharge1Reason: ele[1].additionalCharge1Reason,
                    additionalCharge1ReasonDesc: ele[1].additionalCharge1ReasonDesc,
                    additionalCharge2: ele[1].additionalCharge2 ? ele[1].additionalCharge2 : 0,
                    additionalCharge2Reason: ele[1].additionalCharge2Reason,
                    additionalCharge2ReasonDesc: ele[1].additionalCharge2ReasonDesc,
                    additionalCharges: ele[1].additionalCharges,
                    currentStatus: ele[1].currentStatus,
                    lineStatus: ele[1].lineStatus,
                    manufacturer: ele[1].manufacturer,
                    manufacturerPartNumber: ele[1].manufacturerPartNumber,
                    quoteLineNumber: ele[1].quoteLineNumber,
                    quoteNumber: ele[1].quoteNumber,
                    unitPrice: ele[1]['quotedPrice_' + ele[1].quantity_field_selected],
                    quantity: ele[1]['sellQuantity_' + ele[1].quantity_field_selected],
                    shipToAccountNo: ele[1].shipToAccountNo,
                    targetPrice_quantity_1: ele[1]['targetPrice_' + ele[1].quantity_field_selected],
                    uniqueLineItem: ele[1].uniqueLineItem,
                    endCustomerAccountNo: ele[1].endCustomerAccountNo,
                    customerPartnumber: ele[1]?.customerPartnumber,
                    subtotal: Number(ele[1]['quotedPrice_' + ele[1].quantity_field_selected] * ele[1]['sellQuantity_' + ele[1].quantity_field_selected]) +
                        Number(ele[1].additionalCharge1 || 0) +
                        Number(ele[1].additionalCharge2 || 0),
                    priceSource: ele[1]['quotedCostSource_' + ele[1].quantity_field_selected]
                })
            })

            sessionStorage.setItem(System.storageName.QUOTE_CART_LIST, JSON.stringify(res))
            setNoResultForRFQ(false)
            HelperAnalyticsEvent.quoteCartEvent({ quoteCartDetails: res, event: "quoteCartAddition" })
            window.location.href = QuoteConfig.getQuoteCartRouteURL();
        } else {
            setNoResultForRFQ(true)
        }
    }

    return (
        <>
            <div className="submitted-quote-table mb-5">
                <QuoteDetailSearchFilter />
                 {((currentTabDetail?.count > 0 && currentTabDetail?.api_query_param === 'A' ) && isQuoteExpired === true) &&
                    <NoResultContent message={"This quote has expired. Please submit a new quote by clicking 'Request New Quote' button."} isDisplay={false} />
                }
                {((currentTabDetail?.api_query_param === 'A') && noResultForRFQ === true) &&
                    <NoResultContent message={"Please select a quantity to proceed to checkout."} isDisplay={false} />
                }

                {((currentTabDetail?.api_query_param === 'R' || currentTabDetail?.api_query_param === 'B') && noResultForRFQ === true) &&
                    <NoResultContent message={"No quote is selected. Please select a Quote to proceed"} isDisplay={false} />
                }
               
                <div className="d-flex justify-content-between align-items-end position-relative">
                    <div className="tabs-text-top d-flex align-items-start text-right position-absolute end-0 rnqbutton">
                        {(currentTabDetail?.count > 0 && ((currentTabDetail?.api_query_param === 'R' || currentTabDetail?.api_query_param === 'B') || (currentTabDetail?.api_query_param === 'A' && isQuoteExpired === true))) &&
                            <div className={(currentTabDetail?.api_query_param === 'A' && isQuoteExpired === true) && "bs5 ms-auto d-flex"}>
                                {(currentTabDetail?.api_query_param === 'A' && isQuoteExpired === true) && <span className='w280'><i>Please note that purchasing quoted parts will be a separate transaction from your normal cart.</i> </span>}
                                <button className="bs5 btn btn-primary ms-2 minw170"
                                    onClick={() => { onRequestQuote() }}
                                >
                                    {__check(['REQUEST_NEW_QUOTE']).status ? <i className="fa fa-spinner fa-spin" /> : 'Request New Quote'}
                                </button>
                            </div>
                        }
                        {(currentTabDetail?.api_query_param === 'A' && currentTabDetail?.count > 0 && isQuoteExpired === false) && (
                            <div className="bs5 ms-auto d-flex">
                                <span className='w280'><i>Please note that purchasing quoted parts will be a separate transaction from your normal cart.</i></span>
                                <button className="bs5 btn btn-primary ms-2 minw170"
                                    onClick={() => { onBuyNow() }}
                                >
                                    {__check(['REQUEST_NEW_QUOTE']).status ? <i className="fa fa-spinner fa-spin" /> : 'BUY NOW'}
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="mobile-tab w-100">
                        <ul className="bs5 nav nav-tabs">
                            {Object.entries(homeTabList).map((v) => (
                                <React.Fragment key={v[1].name}>
                                    <li className={'bs5 nav-item'} key={v[1].name}>
                                        <a className={`'nav-link ' + ${getActiveClass(v[1])} ${v[1].count === 0 && 'disabled-link'}`}
                                            href={void (0)} onClick={async () => {
                                                await switchTab(getTabLink(v[1]), v[1])
                                            }}
                                        >
                                            <span>{v[1].name} ({v[1].count})</span>
                                        </a>
                                    </li>

                                </React.Fragment>
                            ))
                            }
                        </ul>
                    </div>

                </div>

                <div
                    id={homeTabList[selectedTab]?.param_value}>
                    {selectedTab === homeTabList.APR.param_value && <ApprovedTabList {...props} current_config={homeTabList[selectedTab]} />}
                    {selectedTab === homeTabList.PND.param_value && <PendingTabList {...props} current_config={homeTabList[selectedTab]} />}
                    {selectedTab === homeTabList.NBD.param_value && <NoBidTabList {...props} current_config={homeTabList[selectedTab]} />}
                    {selectedTab === homeTabList.BKD.param_value && <BookedTabList {...props} current_config={homeTabList[selectedTab]} />}
                </div>
            </div>
        </>
    )
};

export default QuoteDetailTabsListing